export default function LPTriangle(props) {
  return (
    <svg viewBox="0 0 180.7 162" {...props}>
      <path fill="#f4cb82" d="M11.7 12.3l149 137.7.3-138.3z" />
    </svg>
  );
}
